import styled from '@emotion/styled';

export const TimeZone = styled('span')((p) => ({
  color: p.theme.custom.colors.gray.w500
}));
